<template>
  <a-layout>
    <!-- 头部 -->
    <TheHeader></TheHeader>

    <!-- 中间动态加载，改成路由模式-->
    <router-view></router-view>

    <!-- 底部 -->
    <!-- <TheFooter></TheFooter> -->

  </a-layout>
</template>
<!--不要加 setup -->
<script lang="ts">
import { defineComponent } from "vue";
import TheHeader from '@/components/the-header.vue';
import TheFooter from "@/components/the-footer.vue";

// 引入公共样式
import '@/styles/common.css'


export default defineComponent({
  name: 'app',
  components: {
    TheHeader,
    TheFooter,
  },
});
</script>
<style scoped></style>
